import { HttpClient } from '../HttpClient'
import { GetUserInterface } from '../../types/getUserInterface'
/**
 * * Get User's Basic Info
 */
export const GetUser = async ():Promise<GetUserInterface> => {
  try {
    const { data } = await HttpClient.get('api/users/current')
    return await Promise.resolve(data)
  } catch (err) {
    return Promise.reject(err)
  }
}
